import React from "react";

export default function About() {
  return (
    <div className="container my-5">
      {/* Page Title */}
      <div className="text-center mb-5">
        <h1 className="display-4 font-weight-bold">About Us</h1>
        <p className="lead text-muted">
          Welcome to <strong>WSDS Tech Cart</strong> – your trusted online shopping destination.
        </p>
      </div>

      {/* Mission Section */}
      <div className="row mb-5">
        <div className="col-md-6 d-flex align-items-center">
          <div>
            <h2 className="h3 font-weight-bold">Our Mission</h2>
            <p className="text-muted">
              Our mission is to bring convenience to your shopping journey by offering a wide range of
              products, fast delivery, and excellent customer support.
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <img
            src="./images/ourmision.png"
            alt="Our Mission"
            className="img-fluid rounded shadow-sm"
          />
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="mb-5">
        <h2 className="h3 font-weight-bold text-center mb-4">Why Choose Us?</h2>
        <div className="row">
          {[
            "Wide variety of quality products",
            "Affordable deals and offers",
            "Secure payment methods",
            "Fast and reliable delivery",
            "Excellent customer support",
          ].map((reason, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body text-center">
                  <h5 className="card-title">{reason}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Section */}
      <div className="text-center bg-light p-5 rounded shadow-sm">
        <h2 className="h3 font-weight-bold mb-3">Contact Us</h2>
        <p className="mb-2">
          Have questions? Reach out to us anytime:
        </p>
        <p>
          📧 Email:{" "}
          <a href="mailto:support@wsdstech.com" className="text-primary">
            support@wsdstech.com
          </a>
          <br />
          📞 Phone: <strong>+91-9876543210</strong>
        </p>
      </div>
    </div>
  );
}
